import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { PerfilCarnet } from '@/types/carnet';

/**
 * Sesión del empleado en el portal del carnet.
 *
 * Deliberadamente separada de `authStore`: son dos poblaciones distintas de
 * usuarios (empleados por SSO vs. usuarios del panel con usuario y clave) y
 * dos tokens con audiencias distintas. Compartir el store haría que cerrar
 * sesión en uno tumbara al otro, y que un token acabara enviándose a la API
 * que no le corresponde.
 */
interface CarnetState {
  token: string | null;
  empleado: PerfilCarnet | null;

  setSesion: (token: string, empleado: PerfilCarnet) => void;
  actualizarEmpleado: (empleado: PerfilCarnet) => void;
  cerrarSesion: () => void;
}

export const useCarnetStore = create<CarnetState>()(
  persist(
    (set) => ({
      token: null,
      empleado: null,

      setSesion: (token, empleado) => set({ token, empleado }),
      actualizarEmpleado: (empleado) => set({ empleado }),
      cerrarSesion: () => set({ token: null, empleado: null }),
    }),
    {
      // Clave propia: no debe colisionar con 'gsh.auth' del panel.
      name: 'gsh.carnet',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
